module.exports = __webpack_public_path__ + "static/media/  (86).10e8bb7b.jpg";